<p-table
  [scrollable]="true"
  [size]="'small'"
  [value]="licencePlans()"
  scrollHeight="flex"
  stripedRows>
  <ng-template #header>
    <tr>
      <th pResizableColumn pSortableColumn="code">{{ 'licence-plan.code' | translate }}
        <p-sortIcon field="code"/>
      </th>
      <th pResizableColumn pSortableColumn="nameFr">{{ 'product.name-fr' | translate }}
        <p-sortIcon field="nameFr"/>
      </th>
      <th pResizableColumn pSortableColumn="nameNl">{{ 'product.name-nl' | translate }}
        <p-sortIcon field="nameNl"/>
      </th>
      <th pResizableColumn pSortableColumn="nameEn">{{ 'product.name-en' | translate }}
        <p-sortIcon field="nameEn"/>
      </th>
      <th pResizableColumn pSortableColumn="featureCount" style="width: 300px">
        {{ 'licence-plan.feature-count' | translate }}
        <p-sortIcon field="featureCount"/>
      </th>
    </tr>
  </ng-template>
  <ng-template #body let-plan>
    <tr (click)="onRowSelect(plan)" class="cursor-pointer hover:bg-gray-50">
      <td>
        <!-- Read-only code displayed as a muted badge, translated via licence-plan-code.* keys -->
        <span
          class="inline-flex items-center rounded-md bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-200">
          {{ ('licence-plan-code.' + plan.code) | translate }}
        </span>
      </td>
      <td>{{ plan.nameFr }}</td>
      <td>{{ plan.nameNl }}</td>
      <td>{{ plan.nameEn }}</td>
      <td class="text-center tabular-nums">{{ plan.featureCount }}</td>
    </tr>
  </ng-template>
</p-table>
